import { WebsiteUrlTypeEnum } from '@onArte/shared/database/enums';

export class WebsiteUrlUpdateModel {
  public id: string | null;
  public type: WebsiteUrlTypeEnum;
  public prettyUrl: string;
  public realUrl: string | null;
}
